import * as React from "react";
import ContentCard from "../../../../ui-library/content-card/content-card";
import CardContent from "../../../../ui-library/content-card/card-content";
import CardHeading from "../../../../ui-library/content-card/card-heading";
import {
  CovidCaseByCountry_covidCaseOwidByCountry_data,
  CovidCaseByCountry_covidCaseOwidByCountry_latest,
} from "../../../../../apollo-types/CovidCaseByCountry";
import SourceLink from "../../../../ui-library/source-link/source-link";
import { EventCategory } from "../../../../../utils/analytics";
import CardSubHeading from "../../../../ui-library/content-card/card-sub-heading";
import LoadingState from "../../../../ui-library/loading-state/loading-state";
import { COVID_SOURCES } from "../../../../../constants/sources";
import CountryProgressBar from "./country-progress-bar";
import CountrySnapshot from "./country-snapshot";

interface CountrySnapshotCardProps {
  countryName: string;
  headingOverwrite?: string;
  headingDetail: string;
  covidData?: CovidCaseByCountry_covidCaseOwidByCountry_data[] | null;
  lastDayValue: CovidCaseByCountry_covidCaseOwidByCountry_latest;
  loading?: boolean;
}

const CountrySnapshotCard: React.FC<CountrySnapshotCardProps> = ({
  countryName,
  headingDetail,
  headingOverwrite,
  covidData,
  lastDayValue,
  loading,
}) => {
  return (
    <ContentCard>
      <CardContent>
        <CardHeading headingDetail={headingDetail}>
          {headingOverwrite ||
            `Situation overview for ${
              countryName !== "World" ? countryName : "the world"
            }`}
        </CardHeading>

        <CardSubHeading>
          These are confirmed cases only. Actual infections may vary as testing
          regimes never track everyone.
        </CardSubHeading>

        {loading && <LoadingState />}

        {covidData && (
          <CountrySnapshot lastDayValue={lastDayValue} covidData={covidData} />
        )}
        <CountryProgressBar {...lastDayValue} />

        <SourceLink
          sources={[COVID_SOURCES.OWID, COVID_SOURCES.JHU]}
          isDataOnly={true}
          eventCategory={EventCategory.CountryPage}
        />
      </CardContent>
    </ContentCard>
  );
};

export default CountrySnapshotCard;
